import { Component, EventEmitter, HostBinding, Input, Output, ViewEncapsulation } from '@angular/core';

@Component({
  selector: 'nv-icon-button',
  template: require('./nv-icon-button.component.html'),
  styles: [require('./nv-icon-button.scss')],
  encapsulation: ViewEncapsulation.Emulated,
})
export class NvIconButtonComponent {
  /**
   *
   *
   */
  @Input() name: string;

  /**
   *
   *
   */
  @Input() color: string = 'blue';

  /**
   *
   *
   */
  @Input() isInverted: boolean = false;

  /**
   *
   *
   */
  @Input() disabled: boolean = false;

  /**
   *
   *
   */
  @Output() clickButton: EventEmitter<any> = new EventEmitter<any>();

  @HostBinding('class') get getColorCSS() {
    return `${this.color} ${this.name}`;
  }

  @HostBinding('class.is-disabled') get isDisabledCSS() {
    return this.disabled;
  }

  @HostBinding('class.is-inverted') get isInvertedCSS() {
    return this.isInverted;
  }

  handleClick(event: Event) {
    this.clickButton.emit(true); // Emit the `press` event
  }
}
